var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "feedback-wrapper" }, [
    _c("div", { staticClass: "feedback" }, [
      _c("div", { staticClass: "head flexBox" }, [
        _c("span", { staticClass: "flexItem" }, [_vm._v("我想问")]),
        _vm._v(" "),
        _c("span", { staticClass: "confirm", on: { click: _vm.submit } }, [
          _vm._v("提交")
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "describe",
          on: {
            click: function($event) {
              return _vm.$refs.describeinput.focus()
            }
          }
        },
        [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.describe,
                expression: "describe"
              }
            ],
            ref: "describeinput",
            attrs: {
              placeholder: "请描述你的问题...",
              maxlength: "100",
              spellcheck: "false"
            },
            domProps: { value: _vm.describe },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.describe = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "total-count" }, [
            _c("span", {
              staticClass: "count",
              domProps: { textContent: _vm._s(_vm.count) }
            }),
            _c("span", { staticClass: "total" }, [_vm._v("/100")])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-796c41c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-796c41c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/feedback.vue
// module id = null
// module chunks = 